<script>
import { mapState } from 'vuex'
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  extends: Line,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        elements: {
            line: {
                tension: 0
            }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#DBDBDB',
            },
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              fontColor: '#DBDBDB',
              labelString: '合計（人）'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false,
              fontColor: '#DBDBDB'
            },
            ticks: {fontColor: "#DDDDDD"}
          }]
        },
        legend: {
          display: false,
          position: 'bottom'
        },
        animation: {
          duration: 0,
          easing: ""
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  watch: {
    toggleState () {
      this._data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  },
  computed: {
    ...mapState('directtalk', ['toggleState']),
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/DashBoard/Home/LineChart.vue